/* <vita-slider> — scroll-snap carousel with prev/next buttons and dots. */
if (!customElements.get('vita-slider')) {
  customElements.define(
    'vita-slider',
    class VitaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track ? this.track.children : []);
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.slides.length < 2) {
          this.classList.add('is-static');
          return;
        }
        this.prev && this.prev.addEventListener('click', () => this.go(this.index() - 1));
        this.next && this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.raf);
          this.raf = window.requestAnimationFrame(() => this.update());
        }, { passive: true });
        this.update();
      }

      index() {
        const left = this.track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      go(i) {
        const target = Math.max(0, Math.min(this.slides.length - 1, i));
        const slide = this.slides[target];
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      update() {
        const i = this.index();
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll;
      }
    }
  );
}
